import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import helper from 'src/utils/helpers';


//Redux
import { Divider, Typography } from '@material-ui/core';



const useStyles = makeStyles({
  table: {
    width: '100%',
    margin: 'auto'
  },

});




export default function SpanningTable({data}) {
  const classes = useStyles();
  const { principal, loanAmount, rate, term, rateTerm, dueDates } = data;

    let amortization = loanAmount / term;
    console.log(dueDates)
    let dd = dueDates;
  return (
    <>
          <Divider />
      <Table className={classes.table} aria-label="spanning table">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
           Loan Details
            </TableCell>
            <TableCell align="right">Total</TableCell>
          </TableRow>
         
        </TableHead>
        <TableBody>
            <TableRow >
              <TableCell align="left"  colSpan={2}>Principal</TableCell>
              <TableCell align="right"><Typography variant="h5">₱{principal}</Typography></TableCell>
            </TableRow>
            <TableRow >
              <TableCell align="left"  colSpan={2}>Term ({rateTerm})</TableCell>
              <TableCell align="right">{term}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left"  colSpan={2}>Rate ({rateTerm})</TableCell>
              <TableCell align="right">{Number(rate * 100)}%</TableCell>
            </TableRow>
          <TableRow>
            <TableCell align="left" colSpan={2} >Loan Amount</TableCell>
            <TableCell align="right"><Typography variant="h5">₱{Number(loanAmount).toFixed()}</Typography></TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2}>({term}){rateTerm} Due</TableCell>
            <TableCell align="right"><Typography variant="h6" className="text-danger">₱{Number(amortization).toFixed()}</Typography></TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br/>
      <Divider style={{border: 'solid 2px'}}/>
      <Table className={classes.table} aria-label="spanning table">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
            Due Dates
            </TableCell>
            <TableCell align="right">Amount</TableCell>
          </TableRow>
         
        </TableHead>
        <TableBody>
            {dd.map(a => {
                return (
                    <TableRow >
                    <TableCell align="left"  colSpan={2}> <div className="d-block flex-grow-1 "> <Typography variant="body2"  className="font-weight-bold">{helper.numbering(a.dueNo)} Payment (<span className="font-xs">{moment(a.dueDate).from()}</span>)</Typography><Typography variant="body2">{moment(a.dueDate).format('dddd, MMMM Do YYYY')}</Typography></div>  </TableCell>
                    <TableCell align="right"><Typography variant="h5">{helper.toCurrency(a.amountDue)}</Typography></TableCell>
                  </TableRow>
                )
            })}
        
        </TableBody>
      </Table>
    </>
  );
}

// <div className="d-block flex-grow-1 "> <Typography variant="body2"  className="font-weight-bold">{helper.numbering(a.dueNo)} Payment</Typography><Typography variant="body2">{moment(a.dueDate).format('dddd, MMMM Do YYYY')}</Typography></div>  <div className="d-block"><Typography variant="body2" className="ml-2 ">₱ {Number(a.amountDue)}</Typography><Typography variant="body2" className="ml-2 ">{moment(a.dueDate).from()}</Typography></div>